import { makeStyles } from "@material-ui/core";

export const ReportsHomeCss = makeStyles(() => ({

    textV1: {
        fontSize: 18,
        fontWeight: 500,
        marginLeft: 24
    },
    textV2: {
        fontSize: 18,
        fontWeight: 500,
        marginLeft: 20
    },
    textV3: {
        fontSize: 18,
        fontWeight: 500,
        marginLeft: 16
    },
    truckIncomeReportIcon: {
        width: '88px'
    },
    partyIncomeReportIcon: {
        width: '88px'
    },
    cardV1: {
        borderRadius: 8,
        width: 354
    },
    cardContentV1: {
        padding: 24,
        paddingBottom: '24px !important'
    },
    listItemV1: {
        padding: '0px !important',
        borderRadius: 8
    },
    mlV1: {
        marginLeft: 24
    },
    supplierBalanceReportIcon: {
        fontSize: 88
    },
    partyBalanceReportIcon: {
        fontSize: 88
    },
    transactionReportIcon: {
        fontSize: 88
    },
    profitLossReportIcon: {
        fontSize: 88
    },
    gridItemV1: {
        padding: 16,
        paddingBottom: 8
    }

}));